@import '../../../../elements/tooltip/pk-tooltip';
@import './pk-progress-stat-item.variables';

@layer components {
  @keyframes progress-animation {
    0% {
      opacity: 0;
      transform: scale(0) translateY(100%);
    }

    100% {
      opacity: 1;
      transform: scale(1) translateY(0);
    }
  }
}

:host {
  @apply block;
}

.progress-wrapper {
  @apply relative px-0 pb-[--progress-stat-spacing] pt-[--progress-stat-spacing-top] text-[color:--progress-stat-color];
}

[pk-tooltip] {
  animation-name: progress-animation;
  animation-duration: 250ms;
  animation-delay: var(--progress-stat-animation-duration);
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;

  font-size: var(--progress-stat-tooltip);
  font-family: var(--progress-stat-tooltip-ff);

  position: absolute;
  top: var(--progress-stat-tooltip-top);

  opacity: 0;

  &[pk-tooltip-align='left'] {
    margin-left: calc(0px - var(--progress-stat-spacing));
  }

  &[pk-tooltip-align='right'] {
    margin-left: var(--progress-stat-spacing);
  }
}
